module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/abf3df9b90326668ad23bcdaa3f227c1.png";